export default __webpack_public_path__ + "static/media/ecommerce.41b02ef3.jpg";